<div class="container container-input md-button-right" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
  <div fxFlex="80%">
    <button [disabled]="protocoloFiscal.tipoOperacao === 2" mat-button class="align-rigth label colored-orange" (click)="getFile()">BAIXAR PLANILHA PADRÃO</button>
  </div>
  <div fxFlex="20%" class=" padding-left">
    <button [disabled]="protocoloFiscal.tipoOperacao === 2" mat-button color="primary" style="float: right;" class="btn-primary large" (click)="anexarPlanilha()">ANEXAR
      PLANILHA</button>
  </div>
</div>
<form #form>
  <input type="file" [disabled]="protocoloFiscal.tipoOperacao === 2" id="fileUpload" name="fileUpload" multiple="multiple" #fileUpload accept="{{accept}}"
    style="display:none;" (change)="selecionarArquivo($event)" />
</form>